module.exports = __webpack_public_path__ + "img/code-1-1.2c3fd51f.png";